<template>
    <b-container>

        <span class="admin-title">Список подразделов</span>
        <hr class="my-4"> 
        
        <b-container v-if="load.Loading" class="container-tab-spinner">
            <spinner />
        </b-container>
        <b-container v-else>
            <b-tabs content-class="mt-3">

                <!-- Подразделы первой версии -->
                
                <b-tab title="Подразделы версии 1">

                    <b-row>
                        <b-col sm="5" lg = "9">
                            <label>Подраздел</label>
                        </b-col>

                        <b-col cols = "2">
                            <label>Цвет подраздела</label>
                        </b-col>
                    </b-row>

                    <b-row v-for = "(item, index) in subSectionsVersionOne" 
                        :key = "item.id"                    
                        class="mb-13">

                        <b-col class="p-0" sm="5" md="7" lg="9">                    
                            <b-form-input 
                                :id = "index+'subsectionText'"    
                                v-model = "item.Name">
                            </b-form-input>
                        </b-col>

                        <b-col sm="4" md="3" lg="2">                                   
                            <b-input-group :id = "index + 'subsectionColor'">
                                <b-input-group-prepend>
                                    <b-img v-bind="propsImg"
                                        :blank-color="item.Color"
                                        v-on:click="openPickerColor(item)"
                                        class = "img-color">
                                    </b-img>
                                </b-input-group-prepend>
                                <b-form-input v-model ="item.Color" class="sub-section-color"></b-form-input>
                            </b-input-group>
                        </b-col>       

                        <b-col sm="3" md="2" lg="1">                   
                            <b-button 
                                :id = "index + 'subsectionDel'" 
                                class = "del-subDir"
                                v-on:click="deleteSubSectionDialog(index, 'subSectionsVersionOne')">
                                <font-awesome-icon icon="trash-alt" style = "width: 25px;  height: 25px; color: #293138;" />
                            </b-button>
                        </b-col>
                    </b-row>           

                    <b-row>
                        <b-col cols="12">
                            <b-button block variant="outline-dark" v-on:click = "addSubSection('subSectionsVersionOne')">+ Добавить подраздел</b-button>
                        </b-col>
                    </b-row>

                    <hr class="my-4"> 
                    <b-row  class="m-0">
                        <b-col cols="2" class="p-0 mr-10">
                            <b-button block id="admin-btn-save"
                                    class="admin-button"                              
                                    @click="save('subSectionsVersionOne')">
                                Сохранить
                            </b-button>	
                        </b-col>
                        <b-col cols="2" class="p-0">	
                            <b-button block 
                                    id="admin-btn-cancel"
                                    class="admin-button"
                                    @click="cancel('subSectionsVersionOne')">
                                Отмена
                            </b-button>	
                        </b-col>			
                    </b-row>	 
                </b-tab>

                <!-- Подразделы второй версии -->

                <b-tab title="Подразделы версии 2">
                    <b-row>
                        <b-col sm="5" lg = "9">
                            <label>Подраздел</label>
                        </b-col>

                        <b-col cols = "2">
                            <label>Цвет подраздела</label>
                        </b-col>
                    </b-row>

                    <b-row v-for = "(item, index) in subSectionsVersionTwo" 
                        :key = "item.id"                    
                        class="mb-13">

                        <b-col class="p-0" sm="5" md="7" lg="9">                    
                            <b-form-input 
                                :id = "index+'subsectionText'"    
                                v-model = "item.Name">
                            </b-form-input>
                        </b-col>

                        <b-col sm="4" md="3" lg="2">                                   
                            <b-input-group :id = "index + 'subsectionColor'">
                                <b-input-group-prepend>
                                    <b-img v-bind="propsImg"
                                        :blank-color="item.Color"
                                        v-on:click="openPickerColor(item)"
                                        class = "img-color">
                                    </b-img>
                                </b-input-group-prepend>
                                <b-form-input v-model ="item.Color" class="sub-section-color"></b-form-input>
                            </b-input-group>
                        </b-col>       

                        <b-col sm="3" md="2" lg="1">                   
                            <b-button 
                                :id = "index + 'subsectionDel'" 
                                class = "del-subDir"
                                v-on:click="deleteSubSectionDialog(index, 'subSectionsVersionTwo')">
                                <font-awesome-icon icon="trash-alt" style = "width: 25px;  height: 25px; color: #293138;" />
                            </b-button>
                        </b-col>
                    </b-row>           

                    <b-row>
                        <b-col cols="12">
                            <b-button block variant="outline-dark" v-on:click = "addSubSection('subSectionsVersionTwo')">+ Добавить подраздел</b-button>
                        </b-col>
                    </b-row>

                    <hr class="my-4"> 
                    <b-row  class="m-0">
                        <b-col cols="2" class="p-0 mr-10">
                            <b-button block id="admin-btn-save"
                                    class="admin-button"                              
                                    @click="save('subSectionsVersionTwo')">
                                Сохранить
                            </b-button>	
                        </b-col>
                        <b-col cols="2" class="p-0">	
                            <b-button block 
                                    id="admin-btn-cancel"
                                    class="admin-button"
                                    @click="cancel('subSectionsVersionTwo')">
                                Отмена
                            </b-button>	
                        </b-col>			
                    </b-row>	

                     
                </b-tab>

            </b-tabs>

            <modal name="modal-pickerColor" id="picker">                   
                        <sketch-picker v-model="colors"/>  
                        <b-container>
                            <b-row>
                                <b-col cols="6" class="m-0 p-0">
                                    <b-button block 
                                            v-on:click="onClickCancelPickerColor" 
                                            class="btn-sub picker-color red">
                                            Отмена
                                    </b-button>
                                </b-col>
                                <b-col class="m-0 p-0">
                                    <b-button block  
                                            v-on:click="onClickOkPickerColor" 
                                            class="btn-sub picker-color green">
                                            Ок
                                    </b-button>                                    
                                </b-col>
                            </b-row>     
                        </b-container>                  
                    </modal>

        </b-container>
    </b-container>

</template>
<script>

import '@/assets/styles/admin/subSections/subSections.css'

import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import ApiHeaders from '@/store/models/ApiHeaders'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import SubSectionModel from '@/store/models/admin/subSections/SubSection'

export default {
    data: function() {

        let load = new Loading();
        let apiHeadersVersionOne = new ApiHeaders().mapToDto('1.0');
        let apiHeadersVersionTwo = new ApiHeaders().mapToDto('2.0');

        this.getAllSubsections(load, apiHeadersVersionOne);
        this.getAllSubsections(load, apiHeadersVersionTwo);
        return {
            load: load,
            apiHeadersVersionOne: apiHeadersVersionOne,
            apiHeadersVersionTwo: apiHeadersVersionTwo,
            propsImg: {blank: true, width: 40, height: 33.5},
            colors: '#000000',  
            itemSub: null,
            subSectionsVersionOne: [],
            subSectionsCloneVersionOne: [],
            subSectionsVersionTwo: [],
            subSectionsCloneVersionTwo: [],
        }
    },
    methods: {
        getAllSubsections: function (load, apiHeaders) {
            load.Calculate(true);
                 apiService.Admin.SubSections.GetSubSections(apiHeaders)
                .then(response => {
                     if (apiHeaders['api-Version'] == 1.0) {
                        this.subSectionsVersionOne = response.data.map(e => new SubSectionModel().mapFromDto(e));
                        this.subSectionsCloneVersionOne = JSON.parse(JSON.stringify(this.subSectionsVersionOne));
                        load.Calculate(false);
                    } else {
                        this.subSectionsVersionTwo = response.data.map(e => new SubSectionModel().mapFromDto(e));                    
                        this.subSectionsCloneVersionTwo = JSON.parse(JSON.stringify(this.subSectionsVersionTwo));
                        load.Calculate(false);
                     }
                })
                .catch(error => {
                    return load.Calculate(false)
                })  
        },
        
        addSubSection: function (subSectionsVersion) {
            if (subSectionsVersion == 'subSectionsVersionOne') { 
                this.subSectionsVersionOne.push(new SubSectionModel());
            } else {
                this.subSectionsVersionTwo.push(new SubSectionModel());
            }  
        },

        save: function (subSectionsVersion) {   
            if (subSectionsVersion == 'subSectionsVersionOne') {
                if(this.subSectionsVersionOne.some(item => item.Name == "")){
                    dialogService.showAlert('Предупреждение', 'Название подраздела должно быть заполнено.' );
                    return;
                }     
                this.load.Calculate(true);
                let subSectionsDto = JSON.parse(JSON.stringify(this.subSectionsVersionOne));
            
                apiService.Admin.SubSections.PostUpdate(subSectionsDto, this.apiHeadersVersionOne)
                    .then(response => {  
                        this.getAllSubsections(this.load, this.apiHeadersVersionOne).then(() => this.load.Calculate(false));
                    })
                    .catch(error => this.load.Calculate(false));
            } else {
                if(this.subSectionsVersionTwo.some(item => item.Name == "")){
                    dialogService.showAlert('Предупреждение', 'Название подраздела должно быть заполнено.' );
                    return;
                }     
                this.load.Calculate(true);
                let subSectionsDto = JSON.parse(JSON.stringify(this.subSectionsVersionTwo));
                
                apiService.Admin.SubSections.PostUpdate(subSectionsDto, this.apiHeadersVersionTwo)
                    .then(response => {  
                        this.getAllSubsections(this.load, this.apiHeadersVersionTwo).then(() => this.load.Calculate(false));
                    })
                    .catch(error => this.load.Calculate(false));
            }
            
        },

        cancel: function (subSectionsVersion) {
            if (subSectionsVersion == 'subSectionsVersionOne') {
                this.subSectionsVersionOne = JSON.parse(JSON.stringify(this.subSectionsCloneVersionOne));
            } else {
                this.subSectionsVersionTwo = JSON.parse(JSON.stringify(this.subSectionsCloneVersionTwo));
            }
        },

        deleteSubSectionDialog: function (index, subSectionsVersion) {   
                dialogService.showConfirm('Подтверждение удаления', 'При удалении подраздела теги, прикрепленные к данному подразделу будут также удалены.\n Удалить подраздел?')
                    .then(ok => {
                        if (subSectionsVersion == 'subSectionsVersionOne') {
                            this.subSectionsVersionOne.splice(index, 1);
                        } else {
                            this.subSectionsVersionTwo.splice(index, 1);
                        }
                })         
                .catch(cancel => {});
        },

        showModalPickerColor: function(){
            this.$modal.show('modal-pickerColor');
        },

        hideModalPickerColor: function(){
            this.$modal.hide('modal-pickerColor');
        },

        openPickerColor: function(item){
            this.itemSub = item;
            this.colors = item.Color;   
            this.showModalPickerColor();
        },

        onClickOkPickerColor: function(){
            if(this.colors.hex != undefined)
                this.itemSub.Color = this.colors.hex; 

            this.hideModalPickerColor();
        },

        onClickCancelPickerColor: function(){
            this.hideModalPickerColor();
        },

        updateValue: function(value) {
            this.colors = value.hex;
        },

        saveValue: function(item) {
            item.Color = this.colors;
        }
    },
    components: {
        Spinner        
    }
    
}
</script>
